export const queryKeys = {
  products: {
    all: ['products'] as const,
    list: (solutionId?: string) => ['products', solutionId] as const,
  },
  orders: {
    all: ['orders'] as const,
    detail: (orderId: string, warehouseId?: string) =>
      ['orders', orderId, warehouseId] as const,
  },
  marketOrders: {
    all: ['market-orders'] as const,
    list: (solutionId: string) => ['market-orders', solutionId] as const,
  },
  presets: {
    all: ['marketplace-presets'] as const,
  },
  banners: {
    all: ['banners'] as const,
    list: (solutionId?: string) => ['banners', 'list', solutionId] as const,
    schema: () => ['banners', 'schema'] as const,
    editSchema: (bannerId: string) =>
      ['banners', 'editSchema', bannerId] as const,
    display: (solutionId?: string) =>
      ['banners', 'display', solutionId] as const,
  },
};
